<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `Home`,

  computed: {
    ...mapState(`model/client`, [`company`]),
    ...mapState(`model/user`, [`me`]),
  },

  async beforeMount() {
    await this.$store.dispatch(`model/user/fetchMe`);
    await this.$store.dispatch(`model/client/fetchCompany`);

    if (!this.me || !this.me.id) {
      return this.$router.replace({ name: `login` });
    }

    if (this.company.rights.interventions === true) {
      return this.$router.replace({ name: `interventions` });
    }

    if (this.company.rights.workload === true) {
      return this.$router.replace({ name: `workload` });
    }

    return this.$router.replace({ name: `notFound` });
  },
};
</script>
